var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePlayColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.096 9.074.404 17.42l.002.006C.642 18.332 1.45 19 2.412 19c.384 0 .745-.106 1.054-.293l.024-.014 8.657-5.109-4.051-4.51Z",
  fill: "#EA4335"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m15.877 7.652-.008-.005-3.737-2.215L7.92 9.263l4.226 4.32 3.717-2.193a2.134 2.134 0 0 0 1.095-1.872 2.13 2.13 0 0 0-1.082-1.866Z",
  fill: "#FBBC04"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M.404 1.578a2.13 2.13 0 0 0-.071.547v14.75c0 .19.025.373.072.546l7.954-8.134L.404 1.578Z",
  fill: "#4285F4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m8.152 9.5 3.98-4.07L3.485.304A2.045 2.045 0 0 0 2.412 0C1.45 0 .64.668.404 1.576v.002L8.151 9.5Z",
  fill: "#34A853"
})));
export default SvgGooglePlayColor;